import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import http from "../api/http";
import EmailGroup from "../types/emailGroup";

interface EmailGroupState {
  emailGroups?: EmailGroup[];
  status: "idle" | "loading" | "failed";
}

const initialState: EmailGroupState = {
  status: "idle",
};

export const addEmailGroup = createAsyncThunk<EmailGroup, EmailGroup>(
  "email-groups/save",
  async (group: EmailGroup) => {
    const response = await http.post<EmailGroup>("/email-group", group, {
      params: {
        successToast: true,
      },
    });
    return response.data;
  }
);

export const fetchEmailGroups = createAsyncThunk<EmailGroup[]>(
  "email-groups/fetch",
  async () => {
    const response = await http.get<EmailGroup[]>("/email-group");
    return response.data;
  }
);

export const fetchEmailGroup = createAsyncThunk<EmailGroup, number>(
  "email-groups/fetch-one",
  async (id: number) => {
    const response = await http.get<EmailGroup>(`/email-group/${id}`);
    return response.data;
  }
);

export const editEmailGroup = createAsyncThunk<EmailGroup, EmailGroup>(
  "email-groups/edit",
  async (group: EmailGroup) => {
    const response = await http.put<EmailGroup>(
      `/email-group/${group.id}`,
      group,
      {
        params: {
          successToast: true,
        },
      }
    );
    return response.data;
  }
);

export const deleteEmailGroups = createAsyncThunk<null, number>(
  "email-groups/delete",
  async (id: number) => {
    const response = await http.delete(`/email-group/${id}`, {
      params: {
        successToast: true,
      },
    });
    return response.data;
  }
);

const emailGroupSlice = createSlice({
  name: "email",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmailGroups.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchEmailGroups.fulfilled, (state, action) => {
        state.status = "idle";
        state.emailGroups = action.payload;
      })
      .addCase(fetchEmailGroups.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

export default emailGroupSlice.reducer;
